import { Component, OnInit, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { ResourceListForWeekly } from '@pos-app/data';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from 'libs/core-ui/src/lib/services';
import { CoreUiPartialState, getBranch } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import moment from 'moment';
import { DOCUMENT } from '@angular/common';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
  selector: 'app-scheduler-week',
  styleUrls: ['./schedulerWeek.component.scss'],
  templateUrl: './schedulerWeek.component.html',
})
export class SchedulerWeekComponent implements OnInit, AfterViewInit {
  @ViewChild('focus', { static: false }) input: ElementRef;
  public toggleButton: boolean = true;
  unSubscribe$ = new Subject<void>();
  year: number = this.route.snapshot.params.year;
  month: number = this.route.snapshot.params.month;
  day: number = this.route.snapshot.params.day;
  part: number = this.route.snapshot.params.part;
  currentDate: string;
  loading: boolean = false;
  resourceList: Array<ResourceListForWeekly> = [];
  defaultBranch: string;
  date = moment();
  elem;
  fullScreen: boolean = false;
  orderArray: any;
  filteredbyDayOrderArray: any;
  showPrevious: boolean = false;
  dateArray: any;
  part1: boolean = false;
  part2: boolean = false;
  weeklyPart2ViewResoruce: any;
  pageResource;
  firstLoad: boolean = true;
  adjustedCurrentDate: string;
  monthYear: string;
  totalResourceAvailableHours: number;
  totalResourceBookedHours: number;
  totalResourceHours: number;
  drawer?: MatDrawer;

  constructor(
    private route: ActivatedRoute,
    private coreUIStore: Store<CoreUiPartialState>,
    private eventService: EventService,
    private router: Router,

    @Inject(DOCUMENT) private document: any
  ) {}
  ngAfterViewInit(): void {
    document.querySelectorAll('.section1').forEach((element) => element.classList.add('navbarHide'));
  }

  ngOnInit() {
    this.loading = true;
    this.getBranchInfo();
    this.getStartDate();
    this.init(this.firstLoad);
    this.elem = document.documentElement;
  }

  getBranchInfo() {
    this.coreUIStore.pipe(takeUntil(this.unSubscribe$), select(getBranch)).subscribe((x) => {
      this.defaultBranch = x?.BranchCode;
    });
  }
  getStartDate() {
    this.currentDate = this.day.toString() + '/' + this.month.toString() + '/' + this.year.toString();
    this.adjustedCurrentDate = (this.day - 1).toString() + '/' + this.month.toString() + '/' + this.year.toString();
  }

  init(firstLoad = false) {
    let numberOfDays;
    if (this.showPrevious) {
      numberOfDays = -5;
    } else {
      numberOfDays = 5;
    }

    this.loading = true;
    this.eventService
      .fetchRecordsForWeek({
        startDate: firstLoad ? this.adjustedCurrentDate : this.currentDate,
        numberOfDays: numberOfDays.toString(),
        branch: this.defaultBranch,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res: any) => {
        this.loading = false;
        if (res) {
          this.adjustedCurrentDate = '';
          this.dateArray = res?.dateArray;
          this.dateArray.map((el) => {
            el.resourceHoursArray.map((elSub, index) => {
              this.resourceList = [{ resourceID: elSub?.ResourceID, resourceName: elSub?.ResourceName }, ...this.resourceList];
            });
          });
          this.resourceList = this.getUniqueResourceList();
          this.resourceList.sort(function (a, b) {
            return a.resourceID - b.resourceID;
          });
        }
        this.setResourceList();
        this.getMonthYear();
        this.setTotalHours();
      });
  }
  setTotalHours() {
    this.totalResourceAvailableHours = 0;
    this.totalResourceBookedHours = 0;
    this.totalResourceHours = 0;
    this.dateArray.map((el) => {
      this.totalResourceAvailableHours = this.totalResourceAvailableHours + el.TotalResourceAvailableHours;
      this.totalResourceBookedHours = this.totalResourceBookedHours + el.TotalResourceBookedHours;
      this.totalResourceHours = this.totalResourceHours + el.TotalResourceHours;
    });
    this.totalResourceAvailableHours = Math.round((this.totalResourceAvailableHours + Number.EPSILON) * 100) / 100;
    this.totalResourceBookedHours = Math.round((this.totalResourceBookedHours + Number.EPSILON) * 100) / 100;
    this.totalResourceHours = Math.round((this.totalResourceHours + Number.EPSILON) * 100) / 100;
  }
  getPreviousFiveOpenDays() {
    this.currentDate = this.dateArray[0].date;
    this.showPrevious = true;
    this.init();
    this.getMonthYear;
  }
  getMonthYear() {
    if (this.dateArray[0].date.split('/')[2] !== this.dateArray[this.dateArray.length - 1].date.split('/')[2]) {
      this.monthYear =
        moment(this.dateArray[0].date, 'DD/MM/YYYY').format('MMMM ') +
        moment(this.dateArray[0].date, 'DD/MM/YYYY').format('YYYY ') +
        '- ' +
        moment(this.dateArray[this.dateArray.length - 1].date, 'DD/MM/YYYY').format('MMMM ') +
        moment(this.dateArray[0].date, 'DD/MM/YYYY').format('YYYY ');
    } else if (this.dateArray[0].date.split('/')[1] !== this.dateArray[this.dateArray.length - 1].date.split('/')[1]) {
      this.monthYear =
        moment(this.dateArray[0].date, 'DD/MM/YYYY').format('MMMM ') +
        '- ' +
        moment(this.dateArray[this.dateArray.length - 1].date, 'DD/MM/YYYY').format('MMMM ') +
        moment(this.dateArray[0].date, 'DD/MM/YYYY').format('YYYY ');
    } else {
      this.monthYear = moment(this.dateArray[0].date, 'DD/MM/YYYY').format('MMMM ') + moment(this.dateArray[0].date, 'DD/MM/YYYY').format('YYYY ');
    }
  }
  getNextFiveOpenDays() {
    this.currentDate = this.dateArray[this.dateArray.length - 1].date;
    this.showPrevious = false;
    this.init();
    this.getMonthYear();
  }

  openFullscreen() {
    document.querySelectorAll('.section1').forEach((element) => element.classList.add('navbarHide'));
    document.querySelectorAll('.dhx_cal_container_week').forEach((element) => element.classList.add('dhx_cal_containerHide'));
    document.querySelectorAll('.dhx_cal_container').forEach((element) => element.classList.remove('dhx_cal_container'));

    this.fullScreen = true;
    if (this?.elem?.requestFullscreen) {
      this?.elem?.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this?.elem?.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this?.elem?.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this?.elem?.msRequestFullscreen();
    }
  }
  /* Close fullscreen */
  closeFullscreen() {
    this.router.navigateByUrl('pos/scheduler/' + this.currentDate + '/week');
    document.querySelectorAll('.section1').forEach((element) => element.classList.remove('navbarHide'));
    document.querySelectorAll('.dhx_cal_containerHide').forEach((element) => element.classList.add('dhx_cal_container'));
    document.querySelectorAll('.dhx_cal_container_week').forEach((element) => element.classList.remove('dhx_cal_containerHide'));

    this.fullScreen = false;
    if (this?.document?.exitFullscreen) {
      this?.document.exitFullscreen();
    } else if (this.document?.mozCancelFullScreen) {
      /* Firefox */
      this?.document.mozCancelFullScreen();
    } else if (this.document?.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this?.document?.webkitExitFullscreen();
    } else if (this.document?.msExitFullscreen) {
      /* IE/Edge */
      this?.document?.msExitFullscreen();
    }
  }
  getDayOrder(resourceID, day) {
    const filteredAllocatedArray = day.jobArray.filter((el) => el.ResourceAssigned.map((el) => el.ResourceID === resourceID));

    return filteredAllocatedArray;
  }
  checkTrue(order, resourceID) {
    const value = order.ResourceAssigned.filter((el) => el.ResourceID === resourceID);
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getUniqueResourceList() {
    let output = this.resourceList.filter((obj, index, arr) => {
      return (
        this.resourceList.findIndex((o) => {
          return JSON.stringify(o) === JSON.stringify(obj);
        }) === index
      );
    });
    return output;
  }

  getResourceAvailableHours(resource, day) {
    return day?.resourceHoursArray?.filter((el) => el.ResourceID === resource)[0]?.AvailableHours;
  }
  getResourceBookedHours(resource, day) {
    return day?.resourceHoursArray?.filter((el) => el.ResourceID === resource)[0]?.BookedHours;
  }
  getResourceTotalHours(resource, day) {
    return day?.resourceHoursArray?.filter((el) => el.ResourceID === resource)[0]?.TotalHours;
  }

  getformattedDate(date) {
    return moment(date, 'DD/MM/YYYY').format('ddd, MMMM [\r\n]DD');
  }
  goToWeeklyPart1View() {
    this.router.navigateByUrl('pos/scheduler/' + this.currentDate + '/week/1');
  }
  goToWeeklyPart2View() {
    this.router.navigateByUrl('pos/scheduler/' + this.currentDate + '/week/2');
  }
  setResourceList() {
    if (this.part?.toString() === '1') {
      const temp1 = [];
      this.resourceList.map((el, index) => {
        if (index < 13) {
          temp1.push(el);
        }
      });

      this.pageResource = temp1;
    } else if (this.part?.toString() === '2') {
      const temp2 = [];
      this.resourceList.map((el, index) => {
        if (index > 12) {
          temp2.push(el);
        }
      });

      this.pageResource = temp2;
    } else {
      this.pageResource = this.resourceList;
    }
  }
  getScreenStatus() {
    if (this.fullScreen) {
      document.querySelectorAll('.section1').forEach((element) => element.classList.add('navbarHide'));
      document.querySelectorAll('.dhx_cal_container_week').forEach((element) => element.classList.add('dhx_cal_containerHide'));
      document.querySelectorAll('.dhx_cal_container').forEach((element) => element.classList.remove('dhx_cal_container'));

      return true;
    } else {
      document.querySelectorAll('.section1').forEach((element) => element.classList.remove('navbarHide'));
      document.querySelectorAll('.dhx_cal_containerHide').forEach((element) => element.classList.add('dhx_cal_container'));
      document.querySelectorAll('.dhx_cal_container_week').forEach((element) => element.classList.remove('dhx_cal_containerHide'));
      return false;
    }
  }
}
